import { FunctionComponent } from 'react'
import styled, { css } from 'styled-components'

interface LabelProps {
  labelColor: string
  children: string
  className?: string
}

type StyledLabelProps = Pick<LabelProps, 'labelColor'>

const StyledLabel = styled.div<StyledLabelProps>`
  ${({
    theme: {
      colors: { staticWhite },
      typography: {
        catchword: {
          small2: { bundledCSS: small2CatchwordCSS },
        },
      },
      utils: { ellipsis },
    },
    labelColor,
  }) => css`
    box-sizing: border-box;
    ${ellipsis('100%', 1)};
    display: inline-block;
    ${small2CatchwordCSS};
    color: ${staticWhite};
    background-color: ${labelColor};
    padding: 0.28em 0.4em 0.2em;
    text-transform: uppercase;
  `}
`

const Label: FunctionComponent<LabelProps> = ({
  labelColor,
  children,
  className,
}) => {
  return (
    <StyledLabel labelColor={labelColor} className={className}>
      {children}
    </StyledLabel>
  )
}

export default Label
